import React from 'react';
import { QualitySpecifications } from '.';
import { SpecificationContextProvider } from "./SpecificationSessionProvider";

export default function QualityContainer () {

    return (
        <SpecificationContextProvider>
            <QualitySpecifications/>
        </SpecificationContextProvider>
    );
}
